import styles from './KeyHint.module.css'

/* Keyboard shortcut badge shown inside game action buttons. */
export function KeyHint({ keyName }: { keyName: string }) {
  return <kbd className={styles.kbd}>{keyName}</kbd>
}
